import { motion } from 'framer-motion';
import { FaCrown, FaPaw } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../lib/theme';

// Zwykły switch (bez etykiet): lewo = klasyczny, prawo = Imperial.
const ThemeSwitch = ({ className = '' }) => {
  const { t } = useTranslation();
  const { isImperial, toggle } = useTheme();
  const label = `${t('theme.switch_label')}: ${isImperial ? t('theme.imperial') : t('theme.classic')}`;

  return (
    <button
      type="button"
      role="switch"
      aria-checked={isImperial}
      aria-label={label}
      title={label}
      onClick={toggle}
      className={`relative inline-flex h-7 w-[3.25rem] shrink-0 items-center rounded-full border transition-colors duration-300
        border-brand-accent/45 bg-brand-bg-side/60 hover:border-brand-accent/80
        focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-accent focus-visible:ring-offset-2 focus-visible:ring-offset-transparent ${className}`}
    >
      <motion.span
        layout
        transition={{ type: 'spring', stiffness: 520, damping: 34 }}
        className={`absolute flex h-5 w-5 items-center justify-center rounded-full bg-brand-accent text-brand-bg-center shadow-md ${
          isImperial ? 'right-1' : 'left-1'
        }`}
      >
        {isImperial ? <FaCrown className="h-2.5 w-2.5" /> : <FaPaw className="h-2.5 w-2.5" />}
      </motion.span>
    </button>
  );
};

export default ThemeSwitch;
